var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#000F30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8C18.9391 8 17.9217 8.42143 17.1716 9.17157C16.4214 9.92172 16 10.9391 16 12V20C16 21.0609 16.4214 22.0783 17.1716 22.8284C17.9217 23.5786 18.9391 24 20 24C21.0609 24 22.0783 23.5786 22.8284 22.8284C23.5786 22.0783 24 21.0609 24 20V12C24 10.9391 23.5786 9.92172 22.8284 9.17157C22.0783 8.42143 21.0609 8 20 8ZM18.5858 10.5858C18.9609 10.2107 19.4696 10 20 10C20.5304 10 21.0391 10.2107 21.4142 10.5858C21.7893 10.9609 22 11.4696 22 12V20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22C19.4696 22 18.9609 21.7893 18.5858 21.4142C18.2107 21.0391 18 20.5304 18 20V12C18 11.4696 18.2107 10.9609 18.5858 10.5858Z",
    fill: "#fbfbfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18C14 17.4477 13.5523 17 13 17C12.4477 17 12 17.4477 12 18V20C12 22.1217 12.8429 24.1566 14.3431 25.6569C15.6058 26.9195 17.247 27.7165 19 27.9373V30H16C15.4477 30 15 30.4477 15 31C15 31.5523 15.4477 32 16 32H24C24.5523 32 25 31.5523 25 31C25 30.4477 24.5523 30 24 30H21V27.9373C22.753 27.7165 24.3942 26.9195 25.6569 25.6569C27.1571 24.1566 28 22.1217 28 20V18C28 17.4477 27.5523 17 27 17C26.4477 17 26 17.4477 26 18V20C26 21.5913 25.3679 23.1174 24.2426 24.2426C23.1174 25.3679 21.5913 26 20 26C18.4087 26 16.8826 25.3679 15.7574 24.2426C14.6321 23.1174 14 21.5913 14 20V18Z",
    fill: "#fbfbfb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendVoice);
export default __webpack_public_path__ + "static/media/SendVoice.a1cf28432bde1aec44beff38c4605397.svg";
export { ForwardRef as ReactComponent };